import en from './en.json'
import it from './it.json'

export const applicationsTranslations = {
	en,
	it
} as const
